export default {
    admin: 'Admin',
    customer: 'Kunde',
    anonymous: 'Ikke pålogget kunde',
    self: 'Utført av kunde',
    date: 'Dato',
    operator_type: 'Operatørtype',
    operator_name: 'Bruker',
    status: 'Status',
    action_type: 'Handlingstype',
    action_value: 'Handling',
    order_created: 'Billett opprettet',
    note_added: 'Notat opprettet',
    payment_recorded: 'Betaling registrert',
    order_canceled: 'Billett avbestilt',
    leg_canceled: 'Strekning avbestilt',
    contact_info_updated: 'Kontaktinfo oppdatert',
    vehicle_info_updated: 'Kjøretøyinfo oppdatert',
    ticket_email_sent: 'Billett på e-post sendt',
    fee_applied: 'Gebyr pålagt',
    leg_fee_applied: 'Strekningsgebyr pålagt',
    refund_issued: 'Tilbakebetaling utført'
}